import { useEffect, useRef } from "react";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import objectPath from "object-path";

import { toAbsoluteUrl } from "_metronic";
import KTMenu from "_metronic/_assets/js/menu";
import KTOffcanvas from "_metronic/_assets/js/offcanvas";
import * as builder from "_metronic/ducks/builder";
import HMenuItem from "_metronic/layout/header/HMenu/HMenuItem";

const offcanvasOptions = {
  overlay: true,
  baseClass: "kt-header-menu-wrapper",
  closeBy: "kt_header_menu_mobile_close_btn",
  toggleBy: {
    target: "kt_header_mobile_toggler",
    state: "kt-header-mobile__toolbar-toggler--active",
  },
};

const HMenu = () => {
  const offCanvasCommonRef = useRef();
  const ktMenuCommonRef = useRef();
  const location = useLocation();

  // Redux selectors using useSelector hook
  const menuConfig = useSelector((store) => store.builder.menuConfig);
  const ktMenuClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "header_menu",
      toString: true,
    })
  );
  const rootArrowEnabled = useSelector((store) =>
    builder.selectors.getConfig(store, "header.menu.self.root-arrow")
  );
  const headerSelfSkin = useSelector((store) =>
    builder.selectors.getConfig(store, "header.self.skin")
  );
  const ulClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "header_menu_nav",
      toString: true,
    })
  );
  const disabledAsideSelfDisplay = useSelector(
    (store) => objectPath.get(store.builder.layoutConfig, "aside.self.display") === false
  );

  const getHeaderLogo = () => {
    let result = "logo-light.png";
    if (headerSelfSkin && headerSelfSkin !== "dark") {
      result = "logo-dark.png";
    }
    return toAbsoluteUrl(`/media/logos/${result}`);
  };

  const getCurrentUrl = () => {
    return location.pathname.split(/[?#]/)[0];
  };

  const initOffCanvas = () => {
    // eslint-disable-next-line no-undef
    new KTOffcanvas(offCanvasCommonRef.current, offcanvasOptions);
  };

  const initKTMenu = () => {
    let menuOptions = {
      submenu: {
        desktop: "dropdown",
        tablet: "accordion",
        mobile: "accordion",
      },
      accordion: {
        slideSpeed: 200, // accordion toggle slide speed in milliseconds
        expandAll: false, // allow having multiple expanded accordions in the menu
      },
      dropdown: {
        timeout: 50,
      },
    };

    let menuDesktopMode = "accordion";
    if (ktMenuCommonRef.current.getAttribute("data-ktmenu-dropdown") === "1") {
      menuDesktopMode = "dropdown";
    }

    if (typeof objectPath.get(menuOptions, "submenu.desktop") === "object") {
      menuOptions.submenu.desktop = {
        default: menuDesktopMode,
      };
    }

    // eslint-disable-next-line no-undef
    new KTMenu(ktMenuCommonRef.current, menuOptions);
  };

  useEffect(() => {
    // Canvas
    initOffCanvas();
    // Menu
    initKTMenu();
  }, []);

  const items = menuConfig.header.items;
  return (
    <>
      <button className="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn">
        <i className="la la-close" />
      </button>
      <div className="kt-header-menu-wrapper" id="kt_header_menu_wrapper" ref={offCanvasCommonRef}>
        {disabledAsideSelfDisplay && (
          <div className="kt-header-logo">
            <Link to="/">
              <img alt="logo" src={getHeaderLogo()} />
            </Link>
          </div>
        )}

        <div
          id="kt_header_menu"
          className={`kt-header-menu kt-header-menu-mobile ${ktMenuClasses}`}
          ref={ktMenuCommonRef}
        >
          <ul className={`kt-menu__nav ${ulClasses}`}>
            {items.map((item, index) => {
              return (
                <Fragment key={`hmenuList${index}`}>
                  {item.title && (
                    <HMenuItem
                      item={item}
                      currentUrl={getCurrentUrl()}
                      rootArrowEnabled={rootArrowEnabled}
                    />
                  )}
                </Fragment>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default HMenu;
